import { getConfigurationValue }                from 'dmpconnectjsapp-base/helpers/accessors';
import React, { useEffect }                     from 'react';
import { Button, Modal, Spinner }               from 'react-bootstrap';
import { getAction }                            from '../../../dmpconnect/actions';
import commands                                 from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections }                          from 'dmpconnectjsapp-base/constants';
import { connect }                              from 'react-redux';
import { b64EncodeUnicode, b64DecodeUnicode }   from '../../../dmpconnect/utils/dataUtils';
import moment                                   from 'moment';
import { isLoading, isReady }                   from 'dmpconnectjsapp-base/helpers/common';
import { clearSection, setModalError }          from 'dmpconnectjsapp-base/actions';
import { xml2js }                               from 'xml-js';
import { patientDataToRawVitaleData }           from '../../../dmpconnect/helpers/vitaleCard';
import ErrorMessage                             from '../../Common/Message/ErrorMessage';
import { createErrorDetails, createModalError } from '../../../dmpconnect/errors';
import TitleTooltip                             from '../../Common/TitleTooltip';
import { apiErrors }                            from 'dmpconnectjsapp-base/errors';
import { errorTypes }                           from '../../../dmpconnect/errors/errorConfiguration';
import env                                      from '../../../envVariables';
import { vitaleDataType }                       from 'dmpconnectjsapp-base/helpers/vitaleData';
import PatientDataFormModal                     from '../../IMTI/PatientDataFormModal';
import ServiceResultModal                       from '../../IMTI/ServiceResultModal';
import PropTypes                                from 'prop-types';

/**
 * parse the object result of xml2js (with compact = false) to extract all text values with their parent element names as keys
 */
function extractTextValuesWithNames (jsonData) {
  const textValues = {};
  
  function traverse (obj, parentName = '', parentPath = [], parentElement = null) {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        traverse(item, parentName, [...parentPath, index], parentElement);
      });
    } else if (obj && typeof obj === 'object') {
      if (obj.type === 'text' && obj.text !== undefined) {
        // Found a text element, use the parent element name as key
        let cleanName = parentName.replace(/^(ns\d+:|soap:|env:|S:|siram:)/, '');
        
        // Special case: if parent is "Identifiant" and parent element has "R" attribute
        if (cleanName === 'Identifiant' && parentElement && parentElement.attributes && parentElement.attributes.R) {
          cleanName = parentElement.attributes.R;
        }
        
        // Handle duplicates by creating unique keys
        let finalKey = cleanName;
        let counter  = 1;
        while (textValues.hasOwnProperty(finalKey)) {
          finalKey = `${cleanName}_${counter}`;
          counter++;
        }
        
        textValues[finalKey] = obj.text;
      } else if (obj.type === 'element' && obj.name) {
        // This is an element with a name, pass it down as the parent name
        if (obj.elements) {
          traverse(obj.elements, obj.name, [...parentPath, obj.name], obj);
        }
      } else {
        // Continue traversing with current parent name
        Object.values(obj).forEach(value => {
          traverse(value, parentName, parentPath, parentElement);
        });
      }
    }
  }
  
  traverse(jsonData);
  return textValues;
}

function IMTIButton ({
  dispatch,
  vitaleDatatype,
  vitalePatient,
  externalPatientData,
  emptyTlsiRequest,
  tlsiServerName,
  createConnection,
  sendHttpRequest,
  vitaleIndex,
  idam,
  numAm,
  lpsName,
  lpsVersion,
}) {
  
  const [hasDispatched, setHasDispatched]             = React.useState({
    createConnection        : false,
    generateEmptyTlsiRequest: false,
    sendHttpRequest         : false,
  });
  const [displayFormModal, setDisplayFormModal]       = React.useState(false);
  const [docInfo, setDocInfo]                         = React.useState({});
  const [displayErrorMessage, setDisplayErrorMessage] = React.useState(false);
  const [currentIndex, setCurrentIndex]               = React.useState(null);
  const [inputedData, setInputedData]                 = React.useState(null);
  
  useEffect(() => {
    dispatch(clearSection(apiSections.CREATE_CONNECTION));
    dispatch(clearSection(apiSections.GENERATE_EMPTY_TLSI_REQUEST));
    dispatch(clearSection(apiSections.SEND_HTTP_REQUEST));
    
    return () => {
      dispatch(clearSection(apiSections.CREATE_CONNECTION));
      dispatch(clearSection(apiSections.GENERATE_EMPTY_TLSI_REQUEST));
      dispatch(clearSection(apiSections.SEND_HTTP_REQUEST));
    };
  }, []);
  
  const handleDisplayFormModal = () => {
    dispatch(clearSection(apiSections.CREATE_CONNECTION));
    dispatch(clearSection(apiSections.GENERATE_EMPTY_TLSI_REQUEST));
    dispatch(clearSection(apiSections.SEND_HTTP_REQUEST));
    setDisplayErrorMessage(false);
    if (!vitalePatient && !externalPatientData) {
      setDisplayFormModal(true);
    }
    setCurrentIndex(vitaleIndex);
    setHasDispatched({
      createConnection        : false,
      generateEmptyTlsiRequest: false,
      sendHttpRequest         : false,
    });
    dispatch(
      getAction(
        commands.createConnection,
        apiSections.CREATE_CONNECTION,
        {
          s_server        : tlsiServerName,
          i_requestTimeout: 0,
          i_usePkcs11     : 1,
        },
      ),
    );
    setHasDispatched(prev => ({ ...prev, createConnection: true }));
  };
  
  useEffect(() => {
    if (vitalePatient && isReady(createConnection) && !hasDispatched.generateEmptyTlsiRequest && hasDispatched.createConnection) {
      dispatch(
        getAction(
          commands.generateEmptyTlsiRequest,
          apiSections.GENERATE_EMPTY_TLSI_REQUEST,
          {
            LpsInfos            : {
              s_idam   : idam,
              s_name   : lpsName,
              s_numAM  : numAm,
              s_version: lpsVersion,
            },
            i_vitalePatientIndex: vitaleIndex,
            i_useApCvContext    : vitaleDatatype === vitaleDataType.APCV_CONTEXT ? 1 : 0,
            s_service           : 'MT',
            s_version           : '3.0.0',
            s_operation         : 'LireMT',
            i_isDevMode         : Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
          },
        ),
      );
      setHasDispatched(prev => ({ ...prev, generateEmptyTlsiRequest: true }));
      
    } else if (externalPatientData && !vitalePatient && isReady(createConnection) && !hasDispatched.generateEmptyTlsiRequest && hasDispatched.createConnection) {
      const rawPatientData = patientDataToRawVitaleData(externalPatientData, { s_nir: externalPatientData.s_nir });
      
      dispatch(
        getAction(
          commands.generateEmptyTlsiRequestWithRawVitaleData,
          apiSections.GENERATE_EMPTY_TLSI_REQUEST,
          {
            LpsInfos: {
              s_idam   : idam,
              s_name   : lpsName,
              s_numAM  : numAm,
              s_version: lpsVersion,
            },
            ...rawPatientData,
            s_service  : 'MT',
            s_version  : '3.0.0',
            s_operation: 'LireMT',
            i_isDevMode: Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
          },
        ),
      );
      setHasDispatched(prev => ({ ...prev, generateEmptyTlsiRequest: true }));
    }
  }, [createConnection, hasDispatched.createConnection, hasDispatched.generateEmptyTlsiRequest, vitalePatient, vitaleIndex, externalPatientData]);
  
  const handleSendingRequest = (formValues) => {
    let formatedLunar;
    const [day, month, year] = formValues.birthday.split('/');
    const lunarDateDDMMAAAA  = `${day}${month}${year}`;
    if (day > 31 || month > 12) {
      const birthdayLunar = new Date(year, month, day).toString();
      formatedLunar       = moment(birthdayLunar).format('YYYYMMDD');
    }
    if (!vitalePatient && !externalPatientData && isReady(createConnection) && !hasDispatched.generateEmptyTlsiRequest && hasDispatched.createConnection) {
      setHasDispatched(prev => ({ ...prev, generateEmptyTlsiRequest: true }));
      setInputedData(formValues);
      const nirWithSpace   = formValues.nir.slice(0, -2) + ' ' + formValues.nir.slice(-2);
      const patientData    = {
        HealthCoverage    : {
          s_regime: formValues.regime,
          s_center: formValues.center || '',
          s_desk  : formValues.desk || '',
        },
        s_nir             : nirWithSpace,
        s_birthdayYYYYMMDD: lunarDateDDMMAAAA || formatedLunar || moment(formValues.birthday, 'DD/MM/YYYY').format('YYYYMMDD'),
        s_name            : formValues.lastName || '', // unused
        s_birthname       : formValues.birthname || '', // unused
        s_given           : formValues.firstName || '', // unused
        i_quality         : formValues.quality || 1,
        i_birthRank       : formValues.birthRank, // unused
        s_certifiedNir    : formValues.certifiedNir || '', // unused
      };
      const rawPatientData = patientDataToRawVitaleData(patientData, { s_nir: nirWithSpace }, true, false);
      dispatch(
        getAction(
          commands.generateEmptyTlsiRequestWithRawVitaleData,
          apiSections.GENERATE_EMPTY_TLSI_REQUEST,
          {
            LpsInfos: {
              s_idam   : idam,
              s_name   : lpsName,
              s_numAM  : numAm,
              s_version: lpsVersion,
            },
            ...rawPatientData,
            s_service  : 'MT',
            s_version  : '3.0.0',
            s_operation: 'LireMT',
            i_isDevMode: Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
          },
        ),
      );
    }
  };
  
  useEffect(() => {
    if ((vitalePatient || externalPatientData || inputedData) && isReady(emptyTlsiRequest) && !hasDispatched.sendHttpRequest && hasDispatched.generateEmptyTlsiRequest) {
      const decode = b64DecodeUnicode(emptyTlsiRequest.s_answerBodyBuffer);
      let result   = '';
      if (vitalePatient) {
        const certifiedNir = vitalePatient.s_certifiedNir;
        // ${vitaleIndex === 0 ? `
        // ${vitalePatient.s_certifiedNir && vitalePatient.s_certifiedNir !== vitalePatient.s_nir ? `
        result = decode.replace(
          'BODYCONTENTTOREPLACE',
          `<urn2:SI_REQMT xmlns:urn2="urn:ir:si_reqmt" xmlns:urn3="urn:siram:beneficiaire">
            <urn2:Temps>${new Date().toISOString()}</urn2:Temps>
            <urn2:BENEFICIAIRE>
            ${certifiedNir ? `
              <urn3:Nir>
                <urn3:Num>${certifiedNir.slice(0, -3)}</urn3:Num>
                <urn3:Cle>${certifiedNir.slice(-2)}</urn3:Cle>
              </urn3:Nir>
              `
            : ''
          }
              <urn3:NirOD>
                <urn3:Num>${vitalePatient.s_nir.slice(0, -3)}</urn3:Num>
                <urn3:Cle>${vitalePatient.s_nir.slice(-2)}</urn3:Cle>
              </urn3:NirOD>
              <urn3:DateNai>${moment(vitalePatient.s_birthdayYYYYMMDD).format('YYYY-MM-DD')}</urn3:DateNai>
              <urn3:RangNai>${vitalePatient.i_birthRank}</urn3:RangNai>
              <urn3:COUVERTURE>
                <urn3:GrandRegime>${vitalePatient.HealthCoverage.s_regime}</urn3:GrandRegime>
                ${vitalePatient.HealthCoverage && vitalePatient.HealthCoverage.s_desk ? `<urn3:Organisme>${vitalePatient.HealthCoverage.s_desk}</urn3:Organisme>` : ''}
                ${vitalePatient.HealthCoverage && vitalePatient.HealthCoverage.s_center ? `<urn3:EntiteGestion>${vitalePatient.HealthCoverage.s_center}</urn3:EntiteGestion>` : ''}
              </urn3:COUVERTURE>
            </urn2:BENEFICIAIRE>
          </urn2:SI_REQMT>`,
        );
      } else if (externalPatientData) {
        result = decode.replace(
          'BODYCONTENTTOREPLACE',
          `<urn2:SI_REQMT xmlns:urn2="urn:ir:si_reqmt" xmlns:urn3="urn:siram:beneficiaire">
            <urn2:Temps>${new Date().toISOString()}</urn2:Temps>
            <urn2:BENEFICIAIRE>
              <urn3:NirOD>
                <urn3:Num>${externalPatientData.nir.slice(0, -3)}</urn3:Num>
                <urn3:Cle>${externalPatientData.nir.slice(-2)}</urn3:Cle>
              </urn3:NirOD>
              <urn3:DateNai>${moment(externalPatientData.s_birthdayYYYYMMDD).format('YYYY-MM-DD')}</urn3:DateNai>
              <urn3:RangNai>${externalPatientData.rangDeNaissance}</urn3:RangNai>
              <urn3:COUVERTURE>
                <urn3:GrandRegime>${externalPatientData.HealthCoverage.regime}</urn3:GrandRegime>
              </urn3:COUVERTURE>
            </urn2:BENEFICIAIRE>
          </urn2:SI_REQMT>`,
        );
      } else if (inputedData) {
        let formatedLunar;
        let lunarDateAAAAMMDD;
        const [day, month, year] = inputedData.birthday.split('/');
        if (day > 31 || month > 12) {
          lunarDateAAAAMMDD   = `${year}-${month}-${day}`;
          const birthdayLunar = new Date(year, month, day).toString();
          formatedLunar       = moment(birthdayLunar).format('YYYY-MM-DD');
        }
        result = decode.replace(
          'BODYCONTENTTOREPLACE',
          `<urn2:SI_REQMT xmlns:urn2="urn:ir:si_reqmt" xmlns:urn3="urn:siram:beneficiaire">
            <urn2:Temps>${new Date().toISOString()}</urn2:Temps>
            <urn2:BENEFICIAIRE>
              <urn3:NirOD>
                <urn3:Num>${inputedData.nir.slice(0, -2)}</urn3:Num>
                <urn3:Cle>${inputedData.nir.slice(-2)}</urn3:Cle>
              </urn3:NirOD>
              <urn3:DateNai>${lunarDateAAAAMMDD || formatedLunar || moment(inputedData.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD')}</urn3:DateNai>
              <urn3:RangNai>${inputedData.birthRank}</urn3:RangNai>
              <urn3:COUVERTURE>
                <urn3:GrandRegime>${inputedData.regime}</urn3:GrandRegime>
              </urn3:COUVERTURE>
            </urn2:BENEFICIAIRE>
          </urn2:SI_REQMT>`,
        );
      }
      
      dispatch(
        getAction(
          commands.sendHttpRequest,
          apiSections.SEND_HTTP_REQUEST,
          {
            i_connectionHandle: createConnection.i_connectionHandle,
            s_headersBase64   : b64EncodeUnicode('Content-type:application/soap+xml;charset=utf-8'),
            s_httpVerb        : 'POST',
            s_requestBase64   : b64EncodeUnicode(result),
            s_urlPath         : '/lps',
          },
        ),
      );
      setHasDispatched(prev => ({ ...prev, sendHttpRequest: true }));
    }
  }, [emptyTlsiRequest, createConnection, hasDispatched.sendHttpRequest]);
  
  useEffect(() => {
    if (sendHttpRequest.i_httpStatus === 200 && sendHttpRequest.s_answerBodyBufferBase64) {
      setDisplayFormModal(false);
      const decode   = b64DecodeUnicode(sendHttpRequest.s_answerBodyBufferBase64);
      const jsObject = xml2js(decode, { compact: false });
      
      // for CNDA test 4.04
      //       const jsObject = xml2js(`<?xml version="1.0" encoding="UTF-8"?>
      // <soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope">
      // 	<S:Body xmlns:S="http://www.w3.org/2003/05/soap-envelope">
      // 		<SI_INFOMT xmlns:ns7="http://www.InterRegimes.fr/DeclarationMedecinTraitant" xmlns:ns6="http://www.cnamts.fr/REPMTRAIT" xmlns:ns5="http://www.sesam-vitale.fr/XMLschemas/CPS" xmlns:ns4="urn:ir:si_reqmt" xmlns:ns3="http://www.sesam-vitale.fr/XMLschemas/Vitale" xmlns:ns2="urn:siram:beneficiaire" xmlns="urn:ir:si_infomt">
      // 			<Temps>2012-01-27T15:35:47.000+01:00</Temps>
      // 			<MESSAGE>
      // 				<ns2:Code>00</ns2:Code>
      // 				<ns2:Libelle>Médecin traitant trouvé</ns2:Libelle>
      // 			</MESSAGE>
      // 			<BENEFICIAIRE>
      // 				<ns2:NirOD>
      // 					<ns2:Num>1730163220800</ns2:Num>
      // 					<ns2:Cle>92</ns2:Cle>
      // 				</ns2:NirOD>
      // 				<ns2:DateNai>1973-01-01</ns2:DateNai>
      // 				<ns2:RangNai>1</ns2:RangNai>
      // 				<ns2:COUVERTURE>
      // 					<ns2:GrandRegime>01</ns2:GrandRegime>
      // 					<ns2:Organisme>261</ns2:Organisme>
      // 					<ns2:EntiteGestion>9880</ns2:EntiteGestion>
      // 				</ns2:COUVERTURE>
      // 				<ns2:IMT>
      // 					<ns2:Identifiant R="PSAM">991103557</ns2:Identifiant>
      // 					<ns2:Identifiant R="RPPS">99900009970</ns2:Identifiant>
      // 					<ns2:NomUsage>GENE</ns2:NomUsage>
      // 					<ns2:Prenom>ALAIN</ns2:Prenom>
      // 					<ns2:Adresse>
      // 						<ns2:complement/>
      // 						<ns2:numeroVoie>515</ns2:numeroVoie>
      // 						<ns2:indiceRepetition/>
      // 						<ns2:typeVoie>CHE</ns2:typeVoie>
      // 						<ns2:nomVoie>DU MAS DE ROCHET</ns2:nomVoie>
      // 						<ns2:codePostal>34170</ns2:codePostal>
      // 						<ns2:commune>CASTELNAU LE LEZ</ns2:commune>
      // 						<ns2:codePays>FRANCE</ns2:codePays>
      // 					</ns2:Adresse>
      // 				</ns2:IMT>
      // 			</BENEFICIAIRE>
      // 		</SI_INFOMT>
      // 	</S:Body>
      // </soap:Envelope>
      // `, { compact: false });
      
      const textValues = extractTextValuesWithNames(jsObject);
      setDocInfo(textValues);
    } else if (sendHttpRequest.i_httpStatus && sendHttpRequest.i_httpStatus !== 200) {
      setDisplayFormModal(false);
      if (!sendHttpRequest.error) {
        
        const decode   = b64DecodeUnicode(sendHttpRequest.s_answerBodyBufferBase64);
        const jsObject = xml2js(decode, { compact: false });
        const error    = extractTextValuesWithNames(jsObject);
        
        const detail = createErrorDetails('IMTI Error', {
          name       : sendHttpRequest.s_httpStatusLineBuffer,
          message    : error.Erreur,
          description: error.Text,
        });
        
        const modalError = createModalError({
          i_apiErrorType: errorTypes.ApiErrors,
          i_apiErrorCode: apiErrors.OPERATION_FAILED,
        }, [detail]);
        dispatch(setModalError(modalError));
      } else {
        setDisplayErrorMessage(true);
      }
    }
  }, [sendHttpRequest, hasDispatched.sendHttpRequest]);
  
  useEffect(() => {
    if (emptyTlsiRequest && emptyTlsiRequest.error && hasDispatched.generateEmptyTlsiRequest) {
      const detail = createErrorDetails('IMTI Error', {
        name       : emptyTlsiRequest.error.s_apiErrorDescription,
        message    : emptyTlsiRequest.error.s_apiErrorDescription,
        description: emptyTlsiRequest.error.s_apiErrorExtendedInformations,
      });
      
      const modalError = createModalError({
        i_apiErrorType: emptyTlsiRequest.error.i_apiErrorType,
        i_apiErrorCode: emptyTlsiRequest.error.i_apiErrorCode,
      }, [detail]);
      dispatch(setModalError(modalError));
    }
  }, [emptyTlsiRequest, hasDispatched.emptyTlsiRequest]);
  
  // {
  //     "Temps": "2025-09-18T14:36:20.228+02:00",
  //     "Code": "00",
  //     "Libelle": "Médecin traitant trouvé",
  //     "Num": "1730163220800",
  //     "Cle": "92",
  //     "DateNai": "1973-01-01",
  //     "RangNai": "1",
  //     "GrandRegime": "01",
  //     "Organisme": "349",
  //     "EntiteGestion": "9881",
  //     "PSAM": "991103557",
  //     "ADELI": "991103557",
  //     "NomUsage": "GENE",
  //     "Prenom": "ALAIN",
  //     "complement": "RESIDENCE LES TILLEULS",
  //     "numeroVoie": "515",
  //     "indiceRepetition": "B",
  //     "typeVoie": "CHE",
  //     "nomVoie": "DU MAS DE ROCHET",
  //     "codePostal": "34170",
  //     "commune": "CASTELNAU LE LEZ",
  //     "codePays": "FRANCE"
  // }
  return (
    <>
      {((isLoading(createConnection) || isLoading(emptyTlsiRequest) || isLoading(sendHttpRequest)) && currentIndex === vitaleIndex) ?
        <Spinner animation="border" className="ml-3"/> :
        <>
          <TitleTooltip
            id="patients_imti"
            text="Rechercher le médecin traitant d'un patient"
          >
            <div className="d-inline-block">
              <Button
                className="btn-icon-only"
                type="button"
                variant="link"
                size="sm"
                onClick={() => handleDisplayFormModal()}
              >
                <img
                  src="/images/logo/imti-logo.png"
                  alt="IMT"
                  style={{ cursor: 'pointer', height: '50px' }}
                />
              </Button>
            </div>
          </TitleTooltip>
        </>
      }
      {displayErrorMessage && (
        <Modal show={currentIndex === vitaleIndex} onHide={() => {
          setDisplayErrorMessage(false);
          dispatch(clearSection(apiSections.SEND_HTTP_REQUEST));
        }} centered>
          <div className="m-3">
            <ErrorMessage
              error={sendHttpRequest}
              showDetails
              title="Erreur lors de l'envoi"
              message="Une erreur est survenue de la transmition"
            />
          </div>
        </Modal>
      )}
      
      <PatientDataFormModal
        displayFormModalState={[displayFormModal, setDisplayFormModal]}
        currentIndex={currentIndex}
        vitaleIndex={vitaleIndex}
        dispatch={dispatch}
        handleSendingRequest={handleSendingRequest}
      />
      
      <ServiceResultModal
        dispatch={dispatch}
        sendHttpRequest={sendHttpRequest}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        vitaleIndex={vitaleIndex}
        docInfo={docInfo}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  const {
          dmpconnect               : {
            [apiSections.GENERATE_EMPTY_TLSI_REQUEST]: emptyTlsiRequest,
            [apiSections.CREATE_CONNECTION]          : createConnection,
            [apiSections.SEND_HTTP_REQUEST]          : sendHttpRequest,
            [apiSections.VITALE_DATA_SECTION]        : vitaleData,
          },
          dmpconnectConnectorConfig: { tlsiServerName },
          dmpconnectImtiConfiguration,
          
        } = state;
  return {
    emptyTlsiRequest,
    tlsiServerName,
    createConnection,
    sendHttpRequest,
    vitaleDatatype: vitaleData && vitaleData.type,
    active        : getConfigurationValue('active', dmpconnectImtiConfiguration),
    idam          : getConfigurationValue('idam', dmpconnectImtiConfiguration),
    numAm         : getConfigurationValue('numAm', dmpconnectImtiConfiguration),
    lpsName       : getConfigurationValue('lpsName', dmpconnectImtiConfiguration),
    lpsVersion    : getConfigurationValue('lpsVersion', dmpconnectImtiConfiguration),
  };
};

export default connect(mapStateToProps)(IMTIButton);

IMTIButton.propTypes = {
  dispatch           : PropTypes.func.isRequired,
  tlsiServerName     : PropTypes.string.isRequired,
  vitaleDatatype     : PropTypes.string,
  vitalePatient      : PropTypes.object,
  externalPatientData: PropTypes.object,
  emptyTlsiRequest   : PropTypes.object,
  createConnection   : PropTypes.object,
  sendHttpRequest    : PropTypes.object,
  vitaleIndex        : PropTypes.number,
  active             : PropTypes.bool,
  idam               : PropTypes.string,
  numAm              : PropTypes.string,
  lpsName            : PropTypes.string,
  lpsVersion         : PropTypes.string,
};